import './App.css';
import { useState } from 'react';
import SongList from './components/SongList';
import SongUploader from './components/SongUploader';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import { useCookies } from 'react-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [tab, setTab] = useState("list");
  const [cookies, setCookie] = useCookies(['gaia-login']);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const login = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(undefined);
    const options = {
        headers: {
          'Authorization': 'Basic ' + btoa(username + ':' + password),
        }
    };
    fetch('https://europe-west1-voice-of-gaia.cloudfunctions.net/login', options).then((result) => {
      setCookie('gaia-login', username + ':' + password);
      setLoading(false);
    }).catch(() => {
      setError("Login failed");
      setLoading(false);
    })
  }

  return (
    <div className="App">
      { cookies['gaia-login'] ? (
      <Tabs
        id="gaia"
        activeKey={tab}
        onSelect={(k) => setTab(k)}
        className="mb-3">
        <Tab eventKey="list" title="Manage Playlist">
          <SongList/>
        </Tab>
        <Tab eventKey="upload" title="Upload song">
          <SongUploader switchBack={() => { setTab("list") }}/>
        </Tab>
      </Tabs>) : (
         <Card className="p-5" style={{ width: '40%' }}>
           {
             error && (
              <Alert variant="warning">
                {error}
              </Alert>
             )
           }
          { loading && (
              <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
              </Spinner>
              )
          }
          <Form onSubmit={login}>
          <Form.Group as={Row} className="mb-3" controlId="username">
            <Form.Label column sm="2">Username</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={username}  onChange={(e) => {setUsername(e.target.value)}} name="artist"/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="password">
            <Form.Label column sm="2">Password</Form.Label>
            <Col sm="10">
                <Form.Control type="password" value={password}  onChange={(e) => {setPassword(e.target.value)}} name="title"/>
            </Col>
          </Form.Group>
          <Button variant="primary" type="submit">Login</Button>
          </Form>
         </Card>
      )
      }
    </div>
  );
}

export default App;
